import React, { useState, useEffect, useRef } from 'react';
import importAllImg from "../helpers/import-all-imgs";
import {useIntl} from "react-intl";
import Partnerships from "./Partnerships";

const imgs = importAllImg(require.context('../img/npf', false, /\.(png|jpe?g|svg)$/));


function ThrivingCommunities() {

  const { formatMessage, locale } = useIntl();
  const fm = id => formatMessage({id});

  const partnerships = [
    {
      titleKey: 'AGAPE CONNECTING PEOPLE, SINGAPORE',
      descriptionKeys: [
        'Agape is a Singapore company that provides reskilling and employment opportunities for a sustainable community transformation. Agape serves the disadvantaged people who want to turn their lives around – ex-offenders, inmates serving time in Changi, physically challenged persons, and single mothers.'
      ],
      logo: '16033-removebg-preview 1.png',
      status: 'ongoing',
      url: 'https://agape-cp.com/'
    },
    {
      titleKey: 'FUGEE ORG, MALAYSIA',
      descriptionKeys: [
        'Over the last 14 years, Fugee has established itself as a leading educational non-profit that paves the way for refugee education and employability in Kuala Lumpur, Malaysia. They champion equality and access by and with refugees to bridge learning gaps and nurture self reliance to build a truly inclusive society. They have served 600+ students at Fugee School and are currently working with partners and community leaders to exercise a child\'s right to education.'
      ],
      logo: 'image 2308.png',
      status: 'ongoing',
      url: 'https://www.fugee.org/en-sg'
    },
    {
      titleKey: 'UNHCR, THE UN REFUGEE AGENCY, MYANMAR',
      descriptionKeys: [
        'Over a million Rohingya refugees have fled violence in Myanmar in successive waves of displacement since the early 1990s. UNHCR is working to mainstream refugee protection in all refugee settlements. With its partners, it is developing a referral system and safe spaces for survivors of gender-based violence. We are also enhancing efforts to identify and refer children at risk for the appropriate support.'
      ],
      logo: 'UNHCR-1024x410-removebg-preview 1.png',
      status: 'completed',
      url: 'https://www.unhcr.org/emergencies/rohingya-emergency'
    },
    {
      titleKey: 'SYMPAMEALS ĐỒNG CẢM, VIETNAM',
      descriptionKeys: [
        'ĐỒNG CẢM is a private charity fund established in 2005 to help poor cancer patients as well as people in difficult personal circumstances in Hanoi. Offers free meal coupons and milk powder, as well as pays for medical treatment and travel expenses. Also provides scholarships to help children of cancer patients stay in school.'
      ],
      logo: 'dongcamsympa_1-removebg-preview 1.png',
      status: 'completed',
      url: 'https://www.facebook.com/DuAnDongCam/'
    },
    {
      titleKey: 'FRIENDS OF THE UNDERPRIVILEGED, VIETNAM',
      descriptionKeys: [
        'Friends of the Underprivileged (FOU) is a nonprofit group of international friends, who voluntarily get together in our personal capacity, working on the sole vision of helping the underprivileged in Asia regardless of their race, age, gender, religion, or political opinion.',
        'Since 1990, they have helped displaced boat-people who scattered throughout Southeast Asia, battered refugees in East Timor, minor tribes in Myanmar, poor orphans in Cambodia, typhoon victims in Philippines, as well as people with leprosy and their children in Vietnam.'
      ],
      logo: 'FOU_1-removebg-preview 1.png',
      status: 'completed',
      url: 'https://www.fou2asia.org/'
    },
    {
      titleKey: 'EMPOWERING CHILDREN OF VIETNAM, VIETNAM',
      descriptionKeys: [
        'Empowering Children Of Vietnam (ECOV) is a Global Concern which strives to support children in Vietnam. ECOV was established as a Global Concern in 2003 supporting a variety of projects associated with supporting street children with education, shelter and safety. ECOV also supports a variety of orphanages with scholarships and donations to support children with leprosy.'
      ],
      logo: 'image_2127-removebg-preview 1.png',
      status: 'completed',
      url: 'https://www.uwcsea.edu.sg/learning/service/global-service'
    },
  ];

  const resources = [
    {
      logo: 'image 2233.png',
      isSpecial: true,
      bgColor: '#3E7E45',
      text: 'The 17 Sustainable Development Goals of the United Nations to address the world\'s most pressing issues.',
      url: 'https://globalgoals.org/'
    },
    {
      logo: 'image 2235.png',
      isSpecial: true,
      bgColor: '#003334',
      text: 'The Earthshot Prize is a global challenge based on five Earthshots – ambitious goals for 2030 to fix our biggest environmental problems.',
      url: 'https://earthshotprize.org/'
    },
    {
      logo: 'image 2237.png',
      isSpecial: true,
      bgColor: '#0E0E0E',
      text: 'Project Drawdown is the world\'s leading resource for climate solutions. Our mission is to help the world stop climate change.',
      url: 'https://drawdown.org/'
    },
    {
      logo: 'image 2238.png',
      isSpecial: true,
      bgColor: '#000000',
      text: 'B Lab is the nonprofit network transforming the global economy to benefit all people, communities, and the planet.',
      url: 'https://www.bcorporation.net/'
    },
    {
      logo: 'image 2244.png',
      isSpecial: true,
      bgColor: '#71A32B',
      text: 'Protected Planet is the most up to date and complete source of data on protected areas and other effective area-based conservation measures',
      url: 'https://www.protectedplanet.net/en'
    },
    {
      logo: 'image 2240.png',
      isSpecial: true,
      bgColor: '#00283E',
      text: 'Giving to Amplify Earth Action (GAEA) Identifies, convenes and amplifies new and existing public, private and philanthropic partnerships for climate and nature.',
      url: 'https://initiatives.weforum.org/giving-to-amplify-earth-action/home'
    },
    {
      logo: 'image 2245.png',
      isSpecial: true,
      bgColor: '#000000',
      text: 'GreenBiz Group is a media and events company that accelerates the just transition to a clean economy.',
      url: 'https://trellis.net/'
    },
    {
      logo: 'image 2242.png',
      isSpecial: true,
      bgColor: '#001C18',
      text: 'Asia Pacific\'s largest media and business intelligence organisation dedicated to sustainable development and ESG performance.',
      url: 'https://www.eco-business.com/'
    },
    {
      logo: 'image 2246.png',
      isSpecial: true,
      bgColor: '#28A745',
      text: 'Conservation Vietnam is the first NGO licensed by MOHA in the wildlife conservation sector and makes grants to support Vietnamese organisations engaged in conservation activities.',
      url: 'https://conservationvietnam.org/'
    }
  ];

  return (
    <>
      <div className='mt-14 md:mt-24 relative'>
        <img className='hidden md:block w-full' src={imgs['Group 3028 (1).png']}/>
        <img className='md:hidden block w-full' src={imgs['Group 3030.png']}/>

        <div
          className='w-[227px] md:w-[600px] text-center absolute text-lg md:text-5xl font-bold text-white z-1 md:leading-[1.2] top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2'>
          {
            locale === 'en' ? 'Building a world where everyone can live with dignity ' :
              'Xây dựng một thế giới nơi mọi người đều có thể sống bình đẳng'
          }
        </div>
      </div>

      <div className='bg-white py-4 md:py-10 px-5 md:px-[7.5%]'>
        <div className='text-center mb-2 md:mb-3'>
          <h2 className='text-sm md:text-xl font-bold uppercase'>
            {fm('Thriving communities')}
          </h2>
        </div>
        <div className='max-w-[90%] md:max-w-2xl mx-auto'>
          <p className='text-base text-black md:text-2xl leading-relaxed text-center'>
            {fm('We believe that every person has the right to live a life of dignity and have equal opportunity to thrive.')}
          </p>
        </div>
      </div>

      <div className='block md:hidden'>
        <img src={imgs['hai-tran-GFeIKOJNPJY-unsplash 2.png']} className='w-full'/>
      </div>
      <div className='bg-white py-2 md:py-20 px-8 md:px-[7.5%]'>
        <h2 className='text-lg md:text-3xl font-bold mb-2 md:mb-4 text-black'>
          {fm('Poverty Alleviation and Ending Inequality')}
        </h2>
        <div className='flex flex-col md:flex-row gap-8 md:gap-24 items-start'>
          {/* Text Section - Left */}
          <div className='flex-1 md:flex-[2]'>

            <div className='space-y-4 md:space-y-6 text-sm md:text-lg leading-relaxed text-black'>
              <p>
                {fm('Despite some positive signs toward reducing inequality in some dimensions, inequality still persists. Poverty entails more than the lack of income and productive resources to ensure sustainable livelihoods. In order to build a better world from where we found it, we need to support those that are less fortunate and engage them to build truly sustainable ideas. Reducing inequalities and ensuring no one is left behind are integral to how we encourage a pay it forward society.')}
              </p>
              <p>
                {fm('We are committed to supporting organizations and changemakers that help communities to achieve economic self-reliance and sustainable livelihoods.')}
              </p>

            </div>
          </div>
          {/* Image Section - Right */}
          <div className='flex-1 md:flex-[1] w-full md:w-auto hidden md:block'>
            <img
              src={imgs['hai-tran-GFeIKOJNPJY-unsplash 1.png']}
              alt="Who We Are"
              className='w-full h-auto object-cover'
            />
          </div>
        </div>
      </div>

      {/*Partnerships*/}
      <Partnerships partnerships={partnerships}/>

      {/*Connecting with nature*/}
      <div className='bg-[#F5F4EE] py-4 md:py-10 px-5 md:px-[7.5%]'>
        {/* Top Section - Title and Subtitle */}
        <div className='text-center mb-4 md:mb-8'>
          <h2 className='text-lg md:text-3xl font-bold mb-2 md:mb-4 text-black uppercase'>
            {fm('CONNECTING WITH NATURE')}
          </h2>
          <p className='text-base md:text-xl text-black max-w-3xl mx-auto'>
            {fm('We believe in a healthy ecosystem because caring for the Earth is inseparable from caring for one another.')}
          </p>
        </div>

        {/* Mobile Image */}
        <div className='block md:hidden mb-6 mx-auto w-[80%]'>
          <img src={imgs['323022022_475610611414744_6458552405003156046_n 3.png']} className='w-full'
               alt="Connecting with Nature"/>
        </div>

        {/* Bottom Section - Environmental Sustainability */}
        <div className='py-2 md:py-20'>
          <h2 className='text-lg md:text-3xl font-bold mb-2 md:mb-4 text-black'>
            {fm('Environmental Sustainability')}
          </h2>
          <div className='flex flex-col md:flex-row gap-8 md:gap-24 items-start'>
            {/* Text Section - Left */}
            <div className='flex-1 md:flex-[2]'>
              <div className='space-y-4 md:space-y-6 text-sm md:text-lg leading-relaxed text-black'>
                <p>
                  {fm('Climate change is a real and undeniable threat to all humans and walks of life on Earth. The effects are already visible and will be catastrophic unless we act now. Through education, innovation and adherence to our climate commitments, we can make the necessary changes to protect the planet.')}
                </p>
                <p>
                  {fm('While climate action and environmental sustainability initiatives is new to our Family, we are committed to play a part and improving our investment practices. We are keen to learn from Changemakers, experts, organizations and communities on how we can do better to protect our planet. For change to become transformational, our change in mindset must manifest in our actions.')}
                </p>
              </div>
            </div>
            {/* Image Section - Right */}
            <div className='flex-1 md:flex-[1] w-full md:w-auto hidden md:block'>
              <img
                src={imgs['323022022_475610611414744_6458552405003156046_n 2.png']}
                alt="Environmental Sustainability"
                className='w-full h-auto object-cover'
              />
            </div>
          </div>
        </div>
      </div>

      <div className='bg-[#F5F4EE] py-4 md:py-10 px-5 md:px-[7.5%]'>
        <h2 className='text-xl md:text-3xl font-bold mb-4 md:mb-8 text-black text-center md:text-left'>
          {fm('Climate Action Resources')}
        </h2>
        {/* Desktop Grid */}
        <div className='hidden md:grid grid-cols-3 gap-5 md:gap-8 mx-auto'>
          {resources.map((resource, index) => (
            <div
              key={index}
              className='flex flex-col rounded-2xl p-5 md:p-6 relative'
              style={{backgroundColor: resource.bgColor}}
            >
              {/* Logo */}
              <div className='h-16 md:h-20 flex items-center mb-4'>
                <img
                  src={imgs[resource.logo]}
                  alt=""
                  className={`${resource.isSpecial ? 'max-h-16 md:max-h-20 h-auto' : 'h-10 md:h-14'}`}
                />
              </div>

              {/* Text Content */}
              <div className='flex-1 text-white text-sm md:text-base leading-relaxed relative pb-8'>
                <p>{fm(resource.text)}</p>
                {/* Arrow Icon */}
                <span
                  onClick={() => window.open(resource.url, '_blank')}
                  className='absolute bottom-0 right-0 cursor-pointer'
                >
                  <img
                    src={imgs['arrow-down-right-svgrepo-com 1.svg']}
                    alt="Learn more"
                    className='w-5 h-5 md:w-6 md:h-6'
                  />
                </span>
              </div>
            </div>
          ))}
        </div>

        {/* Mobile Grid */}
        <div className='block md:hidden grid grid-cols-2 gap-3'>
          {resources.map((resource, index) => (
            <div
              key={index}
              onClick={() => window.open(resource.url, '_blank')}
              className='flex flex-col rounded-2xl p-4 relative cursor-pointer'
              style={{backgroundColor: resource.bgColor}}
            >
              {/* Logo */}
              <div className='h-12 flex items-center mb-3 flex-1'>
                <img
                  src={imgs[resource.logo]}
                  alt=""
                  className='max-h-12 h-auto'
                />
              </div>

              {/* Arrow Icon */}
              <div className='flex justify-end'>
                <img
                  src={imgs['arrow-down-right-svgrepo-com 1.svg']}
                  alt="Learn more"
                  className='w-5 h-5'
                />
              </div>
            </div>
          ))}
        </div>
      </div>


      {/* bottom part - Quote section */}
      <div
        className='relative -mb-1 md:mb-auto md:py-20 px-5 md:px-10 h-[150px] md:h-[400px] flex items-center justify-end'>
        <img
          src={imgs['Group 30091.png']}
          alt="Quote Background"
          className='absolute inset-0 w-full h-[150px] md:h-auto'
        />
        <div className='relative mt-0 z-10 max-w-[300px] md:max-w-2xl mx-auto'>
          <div className='text-xs md:text-2xl font-bold text-black leading-[1.3] md:leading-relaxed text-center'>
            {
              locale === 'en' ?
                <>
                  We can no longer afford to assume that addressing climate change is the sole responsibility of national or local governments, or corporations or individuals. This is an everyone-everywhere mission in which we all must individually and collectively assume responsibility.
                </> :
                <>
                  Chúng ta không còn đủ khả năng để cho rằng việc giải quyết vấn đề biến đổi khí hậu là trách nhiệm duy nhất của chính quyền quốc gia hoặc địa phương, hoặc các tập đoàn hoặc cá nhân. Đây là sứ mệnh của mọi người ở khắp mọi nơi, trong đó tất cả chúng ta phải chịu trách nhiệm một cách cá nhân và tập thể.
                </>
            }
            <p className='mt-5'>{fm('Christiana Figueres')}</p>
          </div>
        </div>
      </div>

    </>
  )
}

export default ThrivingCommunities;
